import { useMemo, useState } from 'react';
import Step from './Step';

type StepsProps = {
  steps: Record<number, () => React.JSX.Element>;
  show: boolean;
  stepsCompleted: number[];
  onClose: () => void;
  onContinue: () => void;
};

const Steps = ({
  steps,
  show,
  stepsCompleted,
  onClose,
  onContinue,
}: StepsProps) => {
  const [current, setCurrent] = useState<number>(Number(Object.keys(steps)[0]));
  const stepsCount = useMemo(() => Object.keys(steps).length, [steps]);
  const handleStepChange = (stepNum: number) => setCurrent(stepNum);
  const StepContent: () => React.JSX.Element = steps[current];

  return (
    <>
      {show && (
        <Step
          showNext={true}
          showPrev={current > Number(Object.keys(steps)[0])}
          stepNum={current}
          stepsCount={stepsCount}
          progress={(current * 100) / stepsCount}
          isNextEnabled={stepsCompleted.includes(current)}
          onStepChange={handleStepChange}
          onClose={onClose}
          onContinue={onContinue}
        >
          <StepContent />
        </Step>
      )}
    </>
  );
};

export default Steps;
